import debounce from "lodash/debounce";
//Hero banner video player script.

function loadHeroVideo() {
    var video = document.querySelector('.hero__video video');
    if (!video) return;

    ($(window).width() <= 480) ? setVideoBannerSource("data-mobilesource", video) : setVideoBannerSource("data-desktopsource", video);
}

function setVideoBannerSource(dataAttributeName, videoElement) {
    let attributeValue;
    attributeValue = videoElement.getAttribute(dataAttributeName);
    attributeValue !== undefined && videoElement.setAttribute("src", attributeValue);
    videoElement.load();
    videoElement.play();
}

document.addEventListener("DOMContentLoaded", loadHeroVideo);
window.addEventListener('orientationchange', debounce(loadHeroVideo, 300));